import { createTranslationMessages } from '@backstage/frontend-plugin-api';
import { TranslationBlueprint } from '@backstage/plugin-app-react';
import { notificationsTranslationRef } from '@backstage/plugin-notifications/alpha';

export const notificationsTranslation = TranslationBlueprint.make({
  name: 'notifications',
  params: {
    resource: createTranslationMessages({
      ref: notificationsTranslationRef,
      full: false,
      messages: {
        'notificationsPage.title': 'Meldingen',
        'notificationsPage.tableTitle.all_one': 'Alle meldingen ({{count}})',
        'notificationsPage.tableTitle.all_other': 'Alle meldingen ({{count}})',
        'notificationsPage.tableTitle.saved_one':
          'Bewaarde meldingen ({{count}})',
        'notificationsPage.tableTitle.saved_other':
          'Bewaarde meldingen ({{count}})',
        'notificationsPage.tableTitle.unread_one':
          'Ongelezen meldingen ({{count}})',
        'notificationsPage.tableTitle.unread_other':
          'Ongelezen meldingen ({{count}})',
        'notificationsPage.tableTitle.read_one':
          'Gelezen meldingen ({{count}})',
        'notificationsPage.tableTitle.read_other':
          'Gelezen meldingen ({{count}})',
        'filters.title': 'Filters',
        'filters.view.label': 'Weergave',
        'filters.view.unread': 'Ongelezen meldingen',
        'filters.view.read': 'Gelezen meldingen',
        'filters.view.saved': 'Bewaard',
        'filters.view.all': 'Alle',
        'filters.createdAfter.label': 'Verzonden',
        'filters.createdAfter.placeholder': 'Meldingen sinds',
        'filters.createdAfter.last24h': 'Laatste 24 uur',
        'filters.createdAfter.lastWeek': 'Afgelopen week',
        'filters.createdAfter.anyTime': 'Altijd',
        'filters.sortBy.label': 'Sorteer op',
        'filters.sortBy.placeholder': 'Veld om op te sorteren',
        'filters.sortBy.newest': 'Nieuwste bovenaan',
        'filters.sortBy.oldest': 'Oudste bovenaan',
        'filters.sortBy.topic': 'Onderwerp',
        'filters.sortBy.origin': 'Herkomst',
        'filters.severity.label': 'Minimale ernst',
        'filters.severity.critical': 'Kritiek',
        'filters.severity.high': 'Hoog',
        'filters.severity.normal': 'Normaal',
        'filters.severity.low': 'Laag',
        'filters.topic.label': 'Onderwerp',
        'filters.topic.anyTopic': 'Alle onderwerpen',
        'table.emptyMessage': 'Geen gegevens om te tonen',
        'table.pagination.firstTooltip': 'Eerste pagina',
        'table.pagination.labelDisplayedRows': '{from}-{to} van {count}',
        'table.pagination.labelRowsSelect': 'rijen',
        'table.pagination.lastTooltip': 'Laatste pagina',
        'table.pagination.nextTooltip': 'Volgende pagina',
        'table.pagination.previousTooltip': 'Vorige pagina',
        'table.bulkActions.markAllRead': 'Markeer alles als gelezen',
        'table.bulkActions.markSelectedAsRead': 'Markeer selectie als gelezen',
        'table.bulkActions.returnSelectedAmongUnread':
          'Markeer selectie als ongelezen',
        'table.bulkActions.saveSelectedForLater': 'Bewaar selectie voor later',
        'table.bulkActions.undoSaveForSelected':
          'Maak bewaren van selectie ongedaan',
        'table.confirmDialog.title': 'Weet je het zeker?',
        'table.confirmDialog.markAllReadDescription':
          'Markeer alle meldingen als gelezen.',
        'table.confirmDialog.markAllReadConfirmation': 'Markeer alles',
        'table.confirmDialog.cancel': 'Annuleer',
        'table.errors.markAllReadFailed':
          'Alle meldingen als gelezen markeren is mislukt',
        'sidebar.title': 'Meldingen',
        'sidebar.errors.markAsReadFailed':
          'Melding als gelezen markeren is mislukt',
        'sidebar.errors.fetchNotificationFailed': 'Melding ophalen is mislukt',
        'settings.title': 'Instellingen voor meldingen',
        'settings.errorTitle': 'Instellingen laden is mislukt',
        'settings.noSettingsAvailable':
          'Er zijn geen instellingen voor meldingen beschikbaar. Kom later terug.',
        'settings.table.origin': 'Herkomst',
        'settings.table.topic': 'Onderwerp',
        'unreadCard.title_one': 'Laatste ongelezen meldingen ({{count}})',
        'unreadCard.title_other': 'Laatste ongelezen meldingen ({{count}})',
        'unreadCard.viewAll': 'Alles bekijken',
        'unreadCard.emptyState': 'Je bent helemaal bij',
        'unreadCard.columnNotification': 'Melding',
        'unreadCard.columnActions': 'Acties',
        'unreadCard.resultsCount': '{{displayed}} van {{total}} resultaten',
      },
    }),
  },
});
